export default {
      id: "ic_left_arrow_white-usage",
      viewBox: "0 0 10 10",
      url: "/" + "images/icons.3.109.2.svg#ic_left_arrow_white-usage",
      toString: function () {
        return this.url;
      }
    }